// const iboInfoToPersist = {
//     iboNumber: 123,
//     isSponsorNumberProvided: false,
//     sponsorNumber: undefined
// };

const IBO_INFO_key = "LTD_iboInfo"

// write an exported function which takes IBO info to persist and persists it to local storage
const persistIboInfo = (iboInfo) => {
    // persist the IBO info to local storage
    const infoKey = `${IBO_INFO_key}`;
    localStorage.setItem(infoKey, JSON.stringify(iboInfo));
}

// write an exported function which takes IBO number and determines if the IBO info is persisted
const isIboInfoPersisted = () => {
    // determine if the IBO info is persisted
    const infoKey = `${IBO_INFO_key}`;
    return localStorage.getItem(infoKey) !== null;
}

// write an exported function which takes IBO number and retrieves the persisted IBO info
const getIboInfo = () => {
    // retrieve the persisted IBO info
    const infoKey = `${IBO_INFO_key}`;
    return JSON.parse(localStorage.getItem(infoKey));
}

// write an exported function which takes IBO number and removes the persisted IBO info
const removeIboInfo = () => {
    // remove the persisted IBO info
    const infoKey = `${IBO_INFO_key}`;
    localStorage.removeItem(infoKey);
}

const sponsorNumberCheckedId = 'SponsorNumberChecked';
const sponsorNumberElemId = 'SponsorNumber';
const iboNumberElemId = 'IboNumber';
const iboNumberCheckedId = 'IboNumberChecked';

const getIboInfoToPersist = () => {
    const iboNumber = document.getElementById(iboNumberElemId).value;
    const sponsorNumberCheckedElem = $(`#${sponsorNumberCheckedId}`);
    const isSponsorNumberProvided = sponsorNumberCheckedElem.is(':checked');
    if (isSponsorNumberProvided) {
        const sponsorNumber = document.getElementById(sponsorNumberElemId).value;
        return { iboNumber, isSponsorNumberProvided, sponsorNumber };
    }
    return { iboNumber, isSponsorNumberProvided };
}

const setIboInfoFromPersisted = (iboInfo) => {
    document.getElementById(iboNumberElemId).value = iboInfo.iboNumber;
    document.getElementById(sponsorNumberCheckedId).checked = iboInfo.isSponsorNumberProvided;
    if (iboInfo.isSponsorNumberProvided) {
        // set the sponsor number checked to checked
        document.getElementById(iboNumberCheckedId).checked = true;
        document.getElementById(sponsorNumberElemId).value = iboInfo.sponsorNumber;
    } else {
        document.getElementById(sponsorNumberElemId).value = '';
    }
}

export const navigateToAmwayConsent = () => {
    let urlObj = new URL(window.location.href);
    const mainSite = `${urlObj.protocol}//${urlObj.hostname}`;
    const url = `https://account.amway.com/my-account/approved-provider/LTD?redirectURL=${mainSite}`;
    const iboInfoToPersist = getIboInfoToPersist();
    
    persistIboInfo(iboInfoToPersist);
    window.location.href = url;
}

export const setIboInfoOnReturnToRegistration = async (fnAction) => {
    const bodyElem = $('body');
    bodyElem.addClass('waiting');
    if (isIboInfoPersisted()) {
        const iboInfo = getIboInfo();
        setIboInfoFromPersisted(iboInfo);
        removeIboInfo();
        await fnAction(iboInfo.iboNumber);
    }
    bodyElem.removeClass('waiting');
}